export const successfulLottieAnimation = {
  options: {
    path: 'assets/animations/successful.json',
    loop: false
  },
  height: '100%',
  width: '100%'
};
